var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 520 401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.6818555%",
    y1: "50%",
    x2: "-5.04748425%",
    y2: "50%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4f9ff",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6f3ff",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de9ff",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09dcff",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00dbff",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.501126%",
    y1: "50%",
    x2: "-15.3740058%",
    y2: "50%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4fafc",
    stopOpacity: 0.07,
    offset: "5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94f5ef",
    stopOpacity: 0.4,
    offset: "32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54f2e4",
    stopOpacity: 0.66,
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27efdc",
    stopOpacity: 0.84,
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0aeed8",
    stopOpacity: 0.96,
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00edd6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "146.23372%",
    y1: "49.9939151%",
    x2: "47.9848647%",
    y2: "49.9939151%",
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4f9ff",
    stopOpacity: 0.07,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6f3ff",
    stopOpacity: 0.26,
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de9ff",
    stopOpacity: 0.56,
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09dcff",
    stopOpacity: 0.96,
    offset: "97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00dbff",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.7447402%",
    y1: "50.0065929%",
    x2: "144.281895%",
    y2: "50.0065929%",
    id: "D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4fafc",
    stopOpacity: 0.07,
    offset: "5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94f5ef",
    stopOpacity: 0.4,
    offset: "32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54f2e4",
    stopOpacity: 0.66,
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27efdc",
    stopOpacity: 0.84,
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0aeed8",
    stopOpacity: 0.96,
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00edd6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f9ff",
    stopOpacity: 0.02,
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2f3ff",
    stopOpacity: 0.08,
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbeaff",
    stopOpacity: 0.17,
    offset: "36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#adf",
    stopOpacity: 0.3,
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80ccff",
    stopOpacity: 0.48,
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4db8ff",
    stopOpacity: 0.7,
    offset: "80%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12a0ff",
    stopOpacity: 0.93,
    offset: "95%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09f",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "116.109763%",
    y1: "50%",
    x2: "-47.0039201%",
    y2: "50%",
    id: "F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5fbff",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4fafc",
    stopOpacity: 0.07,
    offset: "5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94f5ef",
    stopOpacity: 0.4,
    offset: "32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54f2e4",
    stopOpacity: 0.66,
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27efdc",
    stopOpacity: 0.84,
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0aeed8",
    stopOpacity: 0.96,
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00edd6",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.795 222.057h202.904l-18.334-31.86H492.84L490.388 84.05H170.16l20.698 36.875H57.795z",
    opacity: 0.15,
    fill: "url(#A)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#09f",
    d: "M255.098 53H304l-3.098 17H252z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00dbff",
    d: "M21.073 53H228l-3.073 17H18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M304.078 0H517l-3.267 17H301z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#09f",
    d: "M117.277 0H263l-3.078 17H114z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M446.292 370h-130.8c-6.827 0-11.45-5.5-10.3-12.293l50.913-304.404c1.355-6.978 7.35-12.086 14.437-12.303H492.87c14.418 0 24.162 11.607 21.77 25.93l-47.807 285.536c-1.627 9.687-10.835 17.535-20.54 17.535z",
    fill: "#9ba9c5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M431.462 370H312.614c-11.48 0-19.227-9.26-17.327-20.687L343.31 61.697C345.22 50.27 356.076 41 367.545 41h118.848c11.47 0 19.227 9.26 17.318 20.687l-48.024 287.616C453.787 360.73 442.93 370 431.462 370z",
    fill: "#cdd4e2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M426.16 362H319.195c-10.573 0-17.725-8.477-15.914-18.93l46.23-275.13C351.272 57.478 361.268 49 371.84 49h106.964c10.573 0 17.725 8.477 15.914 18.93l-46.23 275.1c-1.75 10.463-11.757 18.97-22.33 18.97z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.1 65.5h-24a2.63 2.63 0 0 1-2.67-3.18 3.93 3.93 0 0 1 3.74-3.17h24a2.62 2.62 0 0 1 2.67 3.18 3.91 3.91 0 0 1-3.74 3.17zm91.8 0h-12.1a2.64 2.64 0 0 1-2.68-3.18 3.93 3.93 0 0 1 3.74-3.17H482a2.63 2.63 0 0 1 2.67 3.17 3.94 3.94 0 0 1-3.77 3.18z",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#b4bed5"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M475.68 88.08L360.47 88c-2.1.004-3.9 1.53-4.262 3.612l-7.146 42.336a4.33 4.33 0 0 0 .959 3.517 4.32 4.32 0 0 0 3.303 1.535h115.033c2.103-.002 3.9-1.518 4.262-3.593l7.325-42.297a4.33 4.33 0 0 0-.968-3.503 4.32 4.32 0 0 0-3.294-1.528zM450.677 236h-114.55c-2.112 0-3.914 1.536-4.263 3.632l-8.804 52.3a4.36 4.36 0 0 0 .96 3.533 4.3 4.3 0 0 0 3.303 1.536h114.33c2.104.007 3.905-1.516 4.263-3.602l9.022-52.328a4.37 4.37 0 0 0-.964-3.529 4.31 4.31 0 0 0-3.299-1.54zM320.03 309.66l-3.97 24.205a4.45 4.45 0 0 0 .96 3.574c.822 1 2.032 1.56 3.306 1.56H434.53c2.106-.003 3.905-1.542 4.267-3.65l4.138-24.205a4.45 4.45 0 0 0-.956-3.581c-.823-.992-2.034-1.564-3.3-1.563H324.297c-2.107.007-3.906 1.55-4.267 3.66zM465.678 145H350.814a4.34 4.34 0 0 0-4.258 3.612L334.06 222.95a4.34 4.34 0 0 0 .963 3.513 4.32 4.32 0 0 0 3.295 1.538h114.488a4.33 4.33 0 0 0 4.258-3.592l12.873-74.337a4.33 4.33 0 0 0-.95-3.53c-.822-.978-2.033-1.542-3.308-1.54z",
    fill: "#edf0f4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#00dbff",
    d: "M260.064 104H478l-2.945 17H257z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#00edd6",
    d: "M166.058 104H234l-2.92 17H163z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M466.9 166.336H278.14l3.51 6.234H166.57c-13.432 0-25.844 7.142-32.56 18.737s-6.716 25.88 0 37.473 19.128 18.737 32.56 18.737h14.52l2.924-17.13H166.57a20.3 20.3 0 0 1-7.93-1.591c-3.65-1.543-6.772-4.106-9-7.38-3.842-5.703-4.55-12.95-1.883-19.285 1.548-3.637 4.12-6.75 7.404-8.96a20.32 20.32 0 0 1 11.399-3.458h126.966l-3.53-6.175h173.91l2.984-17.2z",
    opacity: 0.8,
    fill: "url(#C)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M370.868 351H175l23.794-140h185.25c2.64-.01 5.147 1.15 6.85 3.166s2.425 4.684 1.974 7.284l-22 129.55z",
    fill: "#9ba9c5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M361.9 351H164l22.484-132.544c.718-4.31 4.447-7.466 8.81-7.456h179.762c2.635-.01 5.14 1.15 6.84 3.166a8.93 8.93 0 0 1 1.971 7.284L361.9 351z",
    fill: "#dfe6ef"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172 344l21.11-124.23c.174-1.026 1.066-1.775 2.107-1.77h179.657a2.13 2.13 0 0 1 1.625.754c.404.478.577 1.1.472 1.727L355.98 344H172z",
    fill: "#00287a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260.766 370H85l2-11.486c.726-4.346 4.473-7.526 8.855-7.514H264l-3.234 19z",
    fill: "#cdd4e2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M359.228 370H252l1.977-11.486c.72-4.346 4.443-7.526 8.796-7.514H370l-1.927 11.476c-.72 4.37-4.47 7.56-8.845 7.524z",
    fill: "#9ba9c5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320 362.77h-52.7a2.52 2.52 0 0 1-2.48-2.94 2.51 2.51 0 0 1 2.48-2.1H320a2.52 2.52 0 0 1 2.48 2.94 2.5 2.5 0 0 1-2.48 2.1zm36.82 0h-22.3a2.52 2.52 0 0 1-2.48-2.94 2.51 2.51 0 0 1 2.48-2.1h22.3a2.52 2.52 0 0 1 2.48 2.94 2.5 2.5 0 0 1-2.48 2.1z",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#b4c0d3"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M525.027 283.9c-5.9-13.884-19.588-22.905-34.747-22.9H210.914L208 278.136h282.28a20.42 20.42 0 0 1 7.956 1.602c8.99 3.76 14.065 13.298 12.133 22.802s-10.337 16.333-20.088 16.325h-17.324L470.043 336h20.237c12.645 0 24.448-6.3 31.436-16.778a37.32 37.32 0 0 0 3.311-35.322z",
    fill: "url(#D)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M322 290H19.913L17 307h302.097z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#09f",
    d: "M304 231H191.894L189 248h112.116z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M376 231h-51.057L322 248h51.057z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#09f",
    d: "M227 319h-51.07L173 336h51.08z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#00dbff",
    d: "M360 318.534L243.9 318l-2.9 17.456 116.1.544z"
  }))), /*#__PURE__*/React.createElement("image", {
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    },
    y: 109.604,
    width: 126,
    height: 126,
    xlinkHref: "data:image/png;base64,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",
    transform: "translate(-1 -.604)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 62.5,
    cy: 171.5,
    r: 50.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0089e5"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.72,
    d: "M63.95 203.748h-.038L46.3 186.126l10.06-10.097 27.68 27.718z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.72,
    d: "M63.912 168.466l-17.66 17.622 10.097 10.06 27.68-27.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.912 138.3l-.038-.038L31.088 171l10.097 10.097L83.99 138.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDevelopment);
export default __webpack_public_path__ + "static/media/appDevelopment.e52a9c34ef4d61fe4012ebc2960ca875.svg";
export { ForwardRef as ReactComponent };